import * as React from "react";
import { List, ListItem, Card as MuiCard, Typography, Box, Grid, IconButton, Tabs, Tab } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useStyles } from "./style";
import logo from "../../../src/assets/logo.png";
import backIcon from "../../../src/assets/icons/backIcon.svg";
import communityBanner from '../../assets/community.svg';
import AllMediaIcon from "../Icons/AllMediaIcon";
import ActiveallMediaIcon from "../Icons/ActiveAllMediaIcon";
import ImageTabIcon from "../Icons/ImageTabIcon";
import ImageActiveTabIcon from "../Icons/ImageActiveTabIcon";
import VideoActiveTabIcon from "../Icons/VideoActiveTabIcon";
import VideoTabIcon from "../Icons/VideoTabIcon";
import CommunityImage1 from '../../assets/communityImage1.png'
import CommunityImage2 from '../../assets/communityImage2.png'
import CommunityImage3 from '../../assets/communityImage3.png'
function AboutCommunity(props) {
  const { community, handleAboutCommunity } = props;
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = React.useState(0);
  const galleryImages = [CommunityImage1, CommunityImage2, CommunityImage3];
  const galleryVideos = Array(12).fill({ type: 'video' }).map((item, index) => ({
    ...item,
    src: galleryImages[index % galleryImages.length],
  }));
  const allMedia = Array(12).fill({}).map((item, index) => ({
    type: index % 2 === 0 ? 'img' : 'video',
    src: galleryImages[index % galleryImages.length],
  }));

  const renderGallery = (data, showVideoIcon = false) => (<>
    <Box className={classes.galleryContainer}>
      <div className={classes.imageGrid}>
        {data.map((item, index) => (
          item.type === 'img' ? (
            <img key={index} src={item.src} alt={`Gallery Image ${index + 1}`} className={classes.galleryImage} />
          ) : (
            <div key={index} className={classes.imageContainer}>
              <img src={item.src} alt={`Gallery Image ${index + 1}`} className={classes.galleryImage} />
              {showVideoIcon && (
                <div className={classes.videoIconContainer}>
                  <VideoTabIcon width={50} height={50} />
                </div>
              )}
            </div>
          )
        ))}
      </div>
    </Box>
    <Box className={classes.pagetitle}>
      <Typography variant="h5" className={classes.communityHeading}>Description</Typography>
    </Box>
    <Box className={classes.pagetitle}>
      <Typography variant="h3" className={classes.description} >
        {
          community?.communityContent?.about ? community?.communityContent?.about : "The Albertville First Nation is a self-governing First Nation located in the Okanagan region of British Columbia. The Albertville First Nation is recognized for its entrepreneurial spirit and has developed several successful business ventures, including shopping centers, residential developments, and tourism facilities."
        }

      </Typography>
    </Box>
    <Box className={classes.pagetitle}>
      <Typography variant="h5" className={classes.communityHeading}>Language</Typography>
    </Box>
    <Box className={classes.pagetitle}>
      <Typography variant="h3" className={classes.description} >The traditional language of the Albertville First Nation is Nsyilxcən (also known as Okanagan or Interior Salish).</Typography>
    </Box>
    <Box className={classes.pagetitle}>
      <Typography variant="h5" className={classes.communityHeading}>Community size</Typography>
    </Box>
    <Box className={classes.pagetitle}>
      <Typography variant="h3" className={classes.description} >
        As of 2021, the Albertville First Nation had a total registered population of approximately 9,000 members, with about 900 members living on reserve lands.
      </Typography>
    </Box>
  </>);

  const handleTabChange = (newValue) => setSelectedTab(newValue);

  const renderTabIcon = (tabIndex, Icon, ActiveIcon) => (
    selectedTab === tabIndex ? (
      <Box className={classes.activeIconWrapper}>
        <Box className={classes.waveShape} />
        <IconButton className={classes.activeIcon}>
          <ActiveIcon width={60} height={60} />
        </IconButton>
      </Box>
    ) : (
      <IconButton className={classes.iconButton} onClick={() => handleTabChange(tabIndex)}>
        <Icon width={40} height={40} />
      </IconButton>
    )
  );

  return (
    <div className={classes.container}>
      <MuiCard className={classes.card}>
        <Box className={classes.header}>
          <Link to="/user/communities/discover"
            onClick={() => handleAboutCommunity(false)}

          ><img src={backIcon} alt="Back" className={classes.backIcon} /></Link>
          <img src={logo} alt="Logo" className={classes.logo} />
        </Box>
        <Box className={classes.pagetitle}>
          <Typography variant="h5" className={classes.communityHeading}>About Community</Typography>
        </Box>
        <Box><img src={communityBanner} style={{ width: "100%" }} /></Box>
        <List className={classes.settingsList}>
          {[
            {
              label: "Community Name", value: community?.communityName
            },
            { label: "Province/ State", value: "British Columbia" }
          ].map((item, index) => (
            <ListItem key={index} className={classes.listItem}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} sm={3} md={4}>
                  <Typography variant="h3" style={{ cursor: "pointer", fontWeight: 400 }}>{item.label}</Typography>
                </Grid>
                <Grid item xs={12} sm={9} md={8}>
                  <Typography variant="h3" style={{ cursor: "pointer", color: "#5C91FF", fontWeight: 400 }}>{item.value}</Typography>
                </Grid>
              </Grid>
            </ListItem>
          ))}
        </List>
        <Box className={classes.toolbarContainer}>
          {renderTabIcon(0, AllMediaIcon, ActiveallMediaIcon)}
          <Box className={classes.iconContainer}>
            {renderTabIcon(1, ImageTabIcon, ImageActiveTabIcon)}
            {renderTabIcon(2, VideoTabIcon, VideoActiveTabIcon)}
          </Box>
        </Box>
        {selectedTab === 0 && renderGallery(allMedia, true)}
        {selectedTab === 1 && renderGallery(allMedia.filter(item => item.type === 'img'))}
        {selectedTab === 2 && renderGallery(galleryVideos, true)}
      </MuiCard>
    </div>
  );
}

export default AboutCommunity;